import { useContext, useEffect } from "react";
import { HtmlGameContext } from "../contexts/HtmlGameProvider";
import { HtmlGameCallbacks, HtmlGameData } from "../types/game";

export const useInitializeGame = (props: {
  gameData?: HtmlGameData;
  callbacks?: HtmlGameCallbacks;
}) => {
  const context = useContext(HtmlGameContext);
  if (context === null) {
    throw new Error("useInitializeGame must be used within a HtmlGameProvider");
  }

  const { setGameData, setCallbacks, controller } = context;
  const { gameData, callbacks } = props;

  useEffect(() => {
    setGameData(gameData);
    setCallbacks(callbacks);
  }, [gameData?.type, setCallbacks, setGameData]);

  useEffect(() => {
    return () => {
      setGameData();
      setCallbacks();
    };
  }, []);

  return controller;
};
